"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var DataFirewallIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.402 15.21c-4.413-.15-7.881-1.505-7.97-3.165L2.431 9.93h.006c.022-.202.1-.398.229-.588.876 1.29 4.106 2.264 8.027 2.344-.406 1.086-.503 2.26-.29 3.523zm2.578 5.245c-.57.043-1.16.066-1.765.066-4.804 0-8.707-1.424-8.783-3.19l-.001-2.115h.006c.022-.201.1-.398.229-.587.89 1.31 4.209 2.294 8.214 2.347.066.18.137.36.214.543a10.181 10.181 0 001.886 2.936z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.992 4.628H20v2.19c0 1.784-3.933 3.23-8.785 3.23-4.851 0-8.784-1.446-8.784-3.23v-2.19h.008c.203-1.624 4.055-2.92 8.776-2.92 4.722 0 8.574 1.296 8.777 2.92z",
    opacity: ".8"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.029 11.952c.994-.585 2.658-.878 4.993-.878 2.336 0 3.989.293 4.96.878.278 1.847.073 3.604-.614 5.27-.762 1.846-2.21 3.31-4.346 4.39-2.175-1.07-3.653-2.533-4.435-4.39-.697-1.656-.883-3.412-.558-5.27z"
  })));
});
DataFirewallIcon.category = 'Content';
var _default = DataFirewallIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/DataFirewallIcon.js
// module id = 1067
// module chunks = 0